import { formatDate } from 'date-fns';

import ChevronRight from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import { Button } from '@simplywallst/ui-core';
import { toCurrencyTruncated } from '@/utilities/formatting';
import Tooltip from '@/components/Tooltip';

import type { CurrencyISO } from '@/constants/currencies';

import { PrimaryNarrativeIcon } from './PrimaryNarrativeIcon';

type Props = {
  currencyISO: CurrencyISO;
  defaultNarrative: {
    fairValue: number;
    type: string;
    narrative: {
      id: string;
      author: {
        id: string;
        displayName: string | null;
        name: string;
        imageUrl: string | null;
      };
      updatedAt: string | null;
      title: string;
    } | null;
  };
};

export const DefaultState = ({ currencyISO, defaultNarrative }: Props) => {
  const { fairValue, narrative } = defaultNarrative;

  if (!narrative) {
    return null;
  }

  return (
    <div className="grid gap-2 h-x12">
      <div className="grid grid-cols-[auto_auto] justify-start items-center gap-x1">
        <div className="grid gap-2 grid-cols-[24px_max-content] items-center">
          <PrimaryNarrativeIcon type="dcf" />
          <div>
            <span className="m-0 text-xs text-solid">
              {toCurrencyTruncated(fairValue || 0, 2, currencyISO ?? 'XXX')}
            </span>
            <span className="sr-only">author fair value</span>
          </div>
        </div>
        {narrative.updatedAt !== null && (
          <div>
            <span className="text-tiny text-softer">
              {formatDate(new Date(narrative.updatedAt), 'dd MMM')}
            </span>
            <span className="sr-only">author updated this narrative</span>
          </div>
        )}
      </div>
      <div className="grid grid-cols-[auto_auto] justify-between items-start gap-x2">
        <h4 className="m-0 text-xs text-soft line-clamp-2">
          {narrative.title}
        </h4>
        <Tooltip
          placement="top-end"
          light
          title={
            <p className="m-0 line-clamp-2 text-tiny text-noir w-48">
              You can select a narrative from the community or create one
              yourself.
            </p>
          }
        >
          <Button styleType="gentle" alignIcon="right">
            Select
            <ChevronRight />
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};
